<div class="gridContainer">
	<sim-labelled-container class="inputForm" icon="fa-user-plus" label="TEAM_TRAINING_SESSION_DIALOG_STEP3_ADD_PARTICIPANT">
		<!--LEARNERS-->
		<sim-autocomplete
			(onSelect)="addParticipant($any($event), ParticipantType.Learner)"
			[dataType]="FetchDataType.SimUser"
			[excludeIds]="excludeIds()"
			[labelToken]="T.TEAM_TRAINING_SESSION_DIALOG_STEP3_SELECT_PARTICIPANT_LEARNER"
			subscriptSizing="fixed"
			[searchFilters]="userSearchFilters()"
		>
			<mat-icon fontIcon="fa-user-md" fontSet="fad" labelPrefix />
		</sim-autocomplete>

		<!--INSTRUCTOR-->
		<sim-autocomplete
			(onSelect)="addParticipant($any($event), ParticipantType.Instructor)"
			[dataType]="FetchDataType.SimUser"
			[excludeIds]="excludeIds()"
			[labelToken]="T.TEAM_TRAINING_SESSION_DIALOG_STEP3_SELECT_PARTICIPANT_INSTRUCTOR"
			subscriptSizing="fixed"
			[searchFilters]="userSearchFilters()"
		>
			<mat-icon fontIcon="fa-user-graduate" fontSet="fad" labelPrefix />
		</sim-autocomplete>

		<!--STANDARDIZED PATIENTS-->
		<sim-autocomplete
			(onSelect)="addParticipant($any($event), ParticipantType.StandardizedPatient)"
			[dataType]="FetchDataType.SimUser"
			[excludeIds]="excludeIds()"
			[labelToken]="T.TEAM_TRAINING_SESSION_DIALOG_STEP3_SELECT_PARTICIPANT_STANDARDIZED_PATIENT"
			subscriptSizing="dynamic"
			[searchFilters]="userSearchFilters()"
		>
			<mat-icon fontIcon="fa-user-injured" fontSet="fad" labelPrefix />
		</sim-autocomplete>
	</sim-labelled-container>
	<sim-list [label]="T.TEAM_TRAINING_SESSION_DIALOG_STEP3_SELECTED_PARTICIPANTS" [counter]="participantCount()" icon="fa-user-check">
		@if (displayParticipants().get(ParticipantType.Instructor)?.length) {
			<div class="subList">
				<label class="secondary"> {{ ParticipantType.Instructor | enumLabel: EnumLabel.TrainingParticipant }} </label>
				@for (participant of displayParticipants().get(ParticipantType.Instructor); track participant.userId) {
					<ng-container *ngTemplateOutlet="listItem; context: {$implicit: participant}" />
				}
			</div>
		}
		@if (displayParticipants().get(ParticipantType.Learner)?.length) {
			<div class="subList">
				<mat-divider />
				<label class="secondary"> {{ ParticipantType.Learner | enumLabel: EnumLabel.TrainingParticipant }} </label>
				@for (participant of displayParticipants().get(ParticipantType.Learner); track participant.userId) {
					<ng-container *ngTemplateOutlet="listItem; context: {$implicit: participant}" />
				}
			</div>
		}
		@if (displayParticipants().get(ParticipantType.StandardizedPatient)?.length) {
			<div class="subList">
				<mat-divider />
				<label class="secondary"> {{ ParticipantType.StandardizedPatient | enumLabel: EnumLabel.TrainingParticipant }} </label>
				@for (participant of displayParticipants().get(ParticipantType.StandardizedPatient); track participant.userId) {
					<ng-container *ngTemplateOutlet="listItem; context: {$implicit: participant}" />
				}
			</div>
		}
	</sim-list>
	@if (selectedParticipant()) {
		<sim-user-details [user]="selectedParticipant().user" />
	}
</div>

<!--TEMPLATE: PARTICIPANT LIST ITEM-->
<ng-template #listItem [ngAs]="Participant" let-participant>
	<sim-user-list-item
		(onDelete)="removeParticipant(participant)"
		(onSelect)="selectedParticipant.set(participant)"
		[deletable]="true"
		[indicatorType]="participant.participantType"
		[selected]="selectedParticipant()?.userId === participant.userId"
		[showOnClickDialog]="false"
		[user]="participant.user"
	/>
</ng-template>
